import formatters from '../utils/formatters';
import L from 'leaflet';
export default class DrawCalc {
    static get OPTIONS() {
        var formatArea = function (a) {
            a = a / 10000;

            return 'Área do polígono (ha)<br>' + formatters.formatNumber(a, 4);
        };

        var formatDistance = function (d) {
            return '';
        };

        return {
            allowIntersection: false,
            drawError: {
                color: '#e1e100',
                message:
                    '<strong>As arestas do polígono não devem se cruzar</strong>'
            },
            shapeOptions: {
                color: '#bada55',
                showMeasurements: false,
                measurementOptions: { formatArea, formatDistance }
            },
            icon: new L.DivIcon({
                iconSize: new L.Point(10, 10),
                className:
                    'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
            }),
            touchIcon: new L.DivIcon({
                iconSize: new L.Point(10, 10),
                className:
                    'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
            })
        };
    }
}
